/** Locale-aware formatting helpers shared by the Store OS dashboard widgets. */

const DEFAULT_LOCALE = 'nl-NL'
const STORE_TIMEZONE = 'Europe/Amsterdam'

export function formatCurrency(
  value: number,
  currency = 'EUR',
  maximumFractionDigits = 2,
): string {
  return new Intl.NumberFormat(DEFAULT_LOCALE, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits,
  }).format(value)
}

export function formatNumber(value: number, maximumFractionDigits = 0): string {
  return new Intl.NumberFormat(DEFAULT_LOCALE, { maximumFractionDigits }).format(value)
}

export function formatPercent(value: number, fractionDigits = 0): string {
  return `${value.toFixed(fractionDigits)}%`
}

/** e.g. `14:32:07` in the store timezone. */
export function formatWallClock(date: Date, timeZone = STORE_TIMEZONE): string {
  return new Intl.DateTimeFormat(DEFAULT_LOCALE, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone,
  }).format(date)
}

/** e.g. `Thursday 16 October`. */
export function formatLongDate(date: Date, timeZone = STORE_TIMEZONE): string {
  return new Intl.DateTimeFormat('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone,
  }).format(date)
}

/** e.g. `16 Oct · 14:32`. */
export function formatShortTimestamp(iso: string, timeZone = STORE_TIMEZONE): string {
  const parsed = new Date(iso)
  if (Number.isNaN(parsed.getTime())) {
    return '--:--'
  }

  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    timeZone,
  }).format(parsed)
}

export { STORE_TIMEZONE }
